import { MenuItem, Select as MuiSelect } from "@mui/material";
import { CellWrapper } from "@silevis/reactgrid";
import type { FC } from "react";
import { resolvePastedSelectOption } from "./resolvePastedSelectOption";

interface SelectProps {
  readonly value: string;
  readonly values: { readonly label: string; readonly value: string | undefined }[];
  readonly readonly?: boolean;
  readonly onSelect: (v: string) => void;
}

const Select: FC<SelectProps> = ({ value, values, readonly, onSelect }) => (
  <MuiSelect
    size="small"
    variant="standard"
    inputProps={{ readOnly: readonly }}
    value={value ?? ""}
    fullWidth
    onChange={(e) => onSelect(e.target.value)}
  >
    {values.map((v) => {
      const text = v.label ?? v.value;
      return (
        <MenuItem key={v.value} value={v.value}>
          {text}
        </MenuItem>
      );
    })}
  </MuiSelect>
);

interface Props {
  readonly values: { readonly label: string; readonly value: string | undefined }[];
  readonly value: string;
  readonly style?: Record<string, string | number>;
  readonly onValueChanged: (v: string) => void;
  /** Maps pasted text to an option value (e.g. nationality / gender synonyms). */
  readonly normalizePasted?: (pastedValue: string) => string | undefined;
}

const SelectCell: FC<Props> = ({ values, value, style, onValueChanged, normalizePasted }) => {
  return (
    <CellWrapper
      onStringValueRequested={() => values.find((v) => v.value === value)?.label ?? ""}
      onStringValueReceived={(pasted) => {
        const matched = resolvePastedSelectOption(values, pasted, normalizePasted);
        if (matched === undefined) {
          return;
        }
        onValueChanged(matched.value ?? "");
      }}
      onPointerDown={(e) => e.stopPropagation()}
      style={{ padding: ".2rem", textAlign: "center", outline: "none", ...style }}
    >
      <Select value={value} values={values} onSelect={onValueChanged} />
    </CellWrapper>
  );
};

export default SelectCell;
